"use client"

import Link from "next/link"
import { usePathname } from "next/navigation"
import { FOOTER_LINK_ITEMS, resolveNavItemHref } from "@/lib/site-navigation"

export function FooterLinks() {
  const pathname = usePathname()

  return (
    <ul className="space-y-2 text-sm text-white/60">
      {FOOTER_LINK_ITEMS.map((item) => (
        <li key={item.name}>
          <Link
            href={resolveNavItemHref(pathname, item)}
            className="hover:text-white transition-colors"
          >
            {item.name}
          </Link>
        </li>
      ))}
    </ul>
  )
}
